/**
 * Normalize axios / Nest error bodies rejected from `api-client` interceptor.
 */
export function formatApiError(error: unknown): string {
  if (error == null) return 'Request failed';
  if (typeof error === 'string') return error;
  if (typeof error !== 'object') return 'Request failed';
  const o = error as Record<string, unknown>;
  if (typeof o.message === 'string') {
    if (Array.isArray(o.message)) {
      return (o.message as unknown[]).map(String).join('; ');
    }
    return o.message;
  }
  if (typeof o.error === 'string') return o.error;
  if (o.errors && typeof o.errors === 'object') {
    const errs = o.errors as Record<string, string>;
    const parts = Object.entries(errs).map(([k, v]) => `${k}: ${v}`);
    if (parts.length) return parts.join('; ');
  }
  return 'Request failed';
}
